import createIcon from '../../createIcon';

/**
 * @component @name SmokeFree
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiA1LjVMOC45OSAxMi41SDJWMTUuNUgxMS45OUwxOC45OSAyMi41TDIwLjI1IDIxLjI1TDMuMjUgNC4yNUwyIDUuNVpNMjAuNSAxMi41SDIyVjE1LjVIMjAuNVYxMi41Wk0xOCAxMi41SDE5LjVWMTUuNUgxOFYxMi41Wk0xOC44NSA0LjM4QzE5LjQ3IDMuNzcgMTkuODUgMi45MyAxOS44NSAySDE4LjM1QzE4LjM1IDMuMDIgMTcuNTIgMy44NSAxNi41IDMuODVWNS4zNUMxOC43NCA1LjM1IDIwLjUgNy4xOCAyMC41IDkuNDJWMTEuNUgyMlY5LjQyQzIyIDcuMTkgMjAuNzIgNS4yNyAxOC44NSA0LjM4Wk0xNC41IDguMkgxNi4wM0MxNy4wOCA4LjIgMTggOC45NCAxOCAxMC4yNVYxMS41SDE5LjVWOS45MUMxOS41IDguMTEgMTcuOSA2Ljc1IDE2LjAzIDYuNzVIMTQuNUMxMy40OCA2Ljc1IDEyLjY1IDUuNzcgMTIuNjUgNC43NUMxMi42NSAzLjczIDEzLjQ4IDMgMTQuNSAzVjEuNUMxMi42NSAxLjUgMTEuMTUgMyAxMS4xNSA0Ljg1QzExLjE1IDYuNyAxMi42NSA4LjIgMTQuNSA4LjJaTTE3IDE1LjQzVjEyLjVIMTQuMDdMMTcgMTUuNDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SmokeFree = createIcon('SmokeFree', [
  [
    'path',
    {
      d: 'M2 5.5L8.99 12.5H2V15.5H11.99L18.99 22.5L20.25 21.25L3.25 4.25L2 5.5ZM20.5 12.5H22V15.5H20.5V12.5ZM18 12.5H19.5V15.5H18V12.5ZM18.85 4.38C19.47 3.77 19.85 2.93 19.85 2H18.35C18.35 3.02 17.52 3.85 16.5 3.85V5.35C18.74 5.35 20.5 7.18 20.5 9.42V11.5H22V9.42C22 7.19 20.72 5.27 18.85 4.38ZM14.5 8.2H16.03C17.08 8.2 18 8.94 18 10.25V11.5H19.5V9.91C19.5 8.11 17.9 6.75 16.03 6.75H14.5C13.48 6.75 12.65 5.77 12.65 4.75C12.65 3.73 13.48 3 14.5 3V1.5C12.65 1.5 11.15 3 11.15 4.85C11.15 6.7 12.65 8.2 14.5 8.2ZM17 15.43V12.5H14.07L17 15.43Z',
      key: 'zehb5e',
    },
  ],
]);

export default SmokeFree;
